import React from 'react';

const technologies = [
  {
    name: 'Cloudflare Workers',
    description: '无服务器计算平台，全球边缘网络部署',
    docs: 'https://developers.cloudflare.com/workers/',
  },
  {
    name: 'Cloudflare D1',
    description: '基于 SQLite 的分布式数据库',
    docs: 'https://developers.cloudflare.com/d1/',
  },
  {
    name: 'React + TypeScript',
    description: '现代化的前端开发栈',
    docs: 'https://reactjs.org/',
  },
  {
    name: 'Tailwind CSS',
    description: '实用优先的 CSS 框架',
    docs: 'https://tailwindcss.com/',
  },
];

export function TechStack() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-primary-600">
            技术标清
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            我们用了什么
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            选择这些技术，是因为它们真的能解决问题，而不是因为它们"很酷"。
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-2">
          {technologies.map((tech) => (
            <div key={tech.name} className="flex flex-col rounded-lg bg-gray-50 p-8 hover:bg-gray-100 transition-colors">
              <h3 className="text-lg font-semibold text-gray-900">{tech.name}</h3>
              <p className="mt-2 text-gray-600 flex-1">{tech.description}</p>
              <a
                href={tech.docs}
                className="mt-4 text-sm font-medium text-primary-600 hover:text-primary-500"
                target="_blank"
                rel="noopener noreferrer"
              >
                查看文档 →
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
